// extracted by mini-css-extract-plugin
export var body = "_ed-8";
export var button = "_ed-0";
export var closeButton = "_ed-5";
export var content = "_ed-3";
export var empty = "_ed-f";
export var grid = "_ed-c";
export var header = "_ed-4";
export var icon = "_ed-1";
export var option = "_ed-d";
export var optionSelected = "_ed-e";
export var overlay = "_ed-2";
export var searchIcon = "_ed-a";
export var searchInput = "_ed-b";
export var searchWrapper = "_ed-9";
export var title = "_ed-6";
export var visuallyHidden = "_ed-7";